import React, {useEffect, useState} from 'react';
import {Paper, TablePagination, LinearProgress} from '@material-ui/core';
import {coreStyle} from "../../styles/config";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Edit from "./add";
import Swal from "sweetalert2";
import TableList from "./tableList";
import {useSelector} from "react-redux";
import Translate, {getDataFromResponse} from "../../utils/utils";
import Search from "../../widgets/Search";


export default function FlowerList(props) {
    const {location: {search}, history, moduleName, isFlower} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [moduleItems, setModuleItems] = useState([]);
    const [moduleItem, setModuleItem] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [groups, setGroups] = useState([]);
    const [categories, setCategories] = useState([]);
    const [name, setName] = useState(queryParams.name);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: perPage,
    });
    const user = useSelector(store => store.auth.user);

    const headCells = [
        {id: 'code', label: <Translate id={"DIALOG.FORM.CODE"}/>},
        {id: 'name', label: <Translate id={"TABLE.NAME"}/>},
        {id: 'group', label: isFlower ? <Translate id={"DIALOG.FORM.GROUP"}/> : <Translate id={"DIALOG.FORM.CATEGORY"}/>},
        {id: 'actions', label: <Translate id={"TABLE.ACTIONS"}/>},
    ];
    const relations = true;

    const removeItemInListing = (id) => {
        const remaining = moduleItems.filter(item => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setModuleItems(remaining);
    };

    useEffect(() => {


        const list = () => {
            setIsLoading(true);
            const categoryResource = new Resource('category');
            const languageResource = new Resource('language');
            const resource = new Resource(moduleName);
            const requests = [
                resource.index({perPage, page, relations, name}),
                languageResource.index(),
                categoryResource.index({relations}),
            ];

            Promise.all(requests).then(([moduleResponse, languageResponse, categoryResponse]) => {
                const {paginationData, data} = getDataFromResponse(moduleResponse);
                setModuleItems(data);
                setPagination(paginationData);
                const {languages} = getDataFromResponse(languageResponse, {responseData: 'languages'});
                setLanguages(languages.reverse());

                const {categories} = getDataFromResponse(categoryResponse, {responseData: 'categories'});

                const groups = categories.reduce((acc, category) => {
                    return acc.concat(category.groups);
                }, []);
                setCategories(categories);
                setGroups(groups);
                setIsLoading(false);

            }).catch(error => {
                setIsLoading(false);
                Swal.fire({
                    icon: 'error',
                    text: 'An error occurred!'
                });
            });
        };
        list();
    }, [page, perPage, relations, moduleName]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };


    const handleCreate = (moduleItem) => {
        setModuleItems([moduleItem, ...moduleItems]);
    };

    const handleUpdate = ({translations, code}, groupId, categoryId) => {

        const moduleItemsList = moduleItems.map(item => {
            translations.forEach(translation => {
                if (moduleItem.id === item.id) {
                    const updatedItem = updateModuleItemParts(groupId, categoryId);
                    if (user?.language_id === parseInt(translation.language_id)) {
                        updatedItem.name = translation.name;
                    }
                    updatedItem.code = (code || item.code);
                    item = updatedItem;
                }
            });
            return item;
        });
        setModuleItems(moduleItemsList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const updateModuleItemParts = (groupId, categoryId) => {

        const categoryResults = categories.filter(category => category.id === categoryId);
        const groupResults = groups.filter(group => group.id === groupId);
        const item = Object.assign({}, moduleItem);

        if (categoryResults.length) {
            item.category_id = categoryId;
            item.category = categoryResults[0];
        }

        if (groupResults.length) {
            item.group_id = groupId;
            item.group = groupResults[0];
        }
        return item;
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button mt-5">
                <Edit handleCreate={handleCreate} handleUpdate={handleUpdate} onCloseModal={() => setModuleItem({})}
                      color={moduleItem} key={moduleItem.id} languages={languages} moduleName={moduleName}
                      moduleItem={moduleItem} isFlower={isFlower} groups={groups} categories={categories}/>
            </div>

            {isLoading && <LinearProgress color="secondary"/>}

            <Search onType={onType} onSubmit={onSearch} module={moduleName} onClear={onClearSearch}
                    disabled={isLoading} value={queryParams.name} onKeyPress={() => {
            }}/>
            <Paper className={coreStyle.paper}>

                <TableList moduleItems={moduleItems} onEditClicked={setModuleItem} moduleName={moduleName}
                           removeItemInListing={removeItemInListing} headCells={headCells} isLoading={isLoading}
                           isFlower={isFlower}
                />
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]}
                    labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
